module.exports = require("./om.d.ts");